import { render, staticRenderFns } from "./SkeletonCard.vue?vue&type=template&id=6accd649&scoped=true&"
import script from "./SkeletonCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonCard.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonCard.vue?vue&type=style&index=0&id=6accd649&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6accd649",
  null
  
)

export default component.exports